import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  recommendationApplied: {
    id: '/prVqy',
    defaultMessage: 'Packaging Recommendation Applied',
    description: 'Title shown after a packing recommendation has been applied to the shipment',
  },
  packageRecommendation: {
    id: 'j6j500',
    defaultMessage: 'Package Recommendation',
    description: 'Title for a packing recommendation card',
  },
  calculationFailed: {
    id: 'WbVtQp',
    defaultMessage: 'Calculation failed. Please try again.',
    description: 'Error text shown when the packing recommendation calculation fails',
  },
  cancel: {
    id: 'Jtqud3',
    defaultMessage: 'Cancel',
    description: 'Label for cancel button on the packing recommendation card',
  },
  recommendPackage: {
    id: '5rGUEY',
    defaultMessage: 'Recommend Package',
    description: 'Label for button that triggers package recommendation',
  },
  dimensionFormat: {
    id: 'yH1s1v',
    defaultMessage: '{length}{unit} \u00d7 {width}{unit} \u00d7 {height}{unit}',
    description: 'Formatted box dimensions with unit symbol (e.g. 12" x 8" x 6")',
  },
  unitInches: {
    id: 'KP9oU/',
    defaultMessage: '"',
    description: 'Unit symbol for inches measurement',
  },
  unitCentimeters: {
    id: 'jp3R7Y',
    defaultMessage: ' cm',
    description: 'Unit symbol for centimeters measurement',
  },
  validationFailed: {
    id: 'nk/gJf',
    defaultMessage: 'Unable to calculate: please ensure items have dimensions and packages are available.',
    description: 'Error notification shown when packing validation fails before calculation',
  },
  packageConfigured: {
    id: 'Pp8+AJ',
    defaultMessage: '{name} configured',
    description: 'Text showing the name of the single package configured after applying a recommendation',
  },
  packagesConfigured: {
    id: 'WcdtRO',
    defaultMessage: '{count, plural, one {# Package} other {# Packages}} configured',
    description: 'Text showing how many packages were configured after applying a recommendation',
  },
  rerun: {
    id: 'RBj+V1',
    defaultMessage: 'Rerun',
    description: 'Link label to re-run the package recommendation calculation',
  },
  makingRecommendation: {
    id: 'Kg8RP2',
    defaultMessage: 'Making Package Recommendation',
    description: 'Text shown while the AI is calculating the package recommendation',
  },
  apply: {
    id: 'l8ghmh',
    defaultMessage: 'Apply',
    description: 'Label for button that applies the package recommendation',
  },
  recommendedPackaging: {
    id: 'JXUgAV',
    defaultMessage: 'Here is your recommended packaging:',
    description: 'Title text shown in the recommendation banner when results are ready',
  },
  itemsInPackage: {
    id: 'A7taZj',
    defaultMessage: '{count, plural, one {# item} other {# items}} in <bold>{packageName}</bold>',
    description: 'Text showing how many items fit in the recommended package',
  },
  andMorePackages: {
    id: 'S5BQpd',
    defaultMessage: 'and {count, plural, one {# more package} other {# more packages}}',
    description: 'Text showing how many additional packages are not displayed in the list',
  },
});
